// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c09ab5e","239":"c6252788","453":"c3d18ba1","667":"9313373b"}[chunkId] + ".chunk.js";
};